export default __webpack_public_path__ + "static/media/cp_geo_cl.60dc704f.svg";